import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const AutomationPeriodInputI18n = {
  configuration: { namespace: I18nNamespace.AUTOMATION_PERIOD_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.automationPeriod,
    placeholder: dictionary.automationPeriod,
    validationMaximumError: dictionary.validationMaximumError,
    validationMinimumError: dictionary.validationMinimumError,
    validationRequiredError: dictionary.validationRequiredError,
  },
};
